/* eslint-disable no-use-before-define */
import React from 'react'
import { parseJson, show, subscribe, unsubscribe } from '../../twd'

export default ({data, index, table}) => {
    let t = index === 0
        ? data.displayName
        : formatYield(data.yield)

    const [text, setText] = React.useState(t)
    const [cellId] = React.useState(data.id)
    React.useEffect(() => {
        let subId = subscribe('yield_bucket.yield_grid_' + cellId, ({id, value}) => {
            return (id===cellId)
                && setText(formatYield(value))
        })
        return () => {
            unsubscribe(subId)
        }
    }, [])

    let q = data.queryText
    if (!q) return text

    if (text==='-') return text

    return <button
        data-name="overview-yield-grids-cell"
        data-cell-id={cellId}
        data-table={table}
        data-row={data.headerName}
        data-column={data.colName}
        onClick={() => onSearch(parseJson(q))}
        className="link-button text-left">{text}</button>
}

let formatYield = (x) => {
    let a = parseFloat(x)
    if (isNaN(a)) return '-'

    let s = a.toFixed(3)
    if (s==='0.000') return '-'
    return s + '%'
}

let onSearch = (p) => {
    if (!p) return
    Object.assign(p, {
        respectSplitRating: true,
        persistToPreviousSearches: false,
        sort: [{ field:'askYield', direction:'DESC' }]
    })
    delete p['savedQuickPickId']

    show('offerings', Object.assign({
        searchParams: p,
        _ts: Date.now(),
        from:'overview'
    }))
}




// WEBPACK FOOTER //
// ./src/overview/yield-grids/cell.js